export enum ResponseControl {
  TTS_PRONUNCIATION = 'tts-pronunciation',
  STOP_KEYWORDS = 'phrase-filtering',
}
